/**
 * 지원되는 AI 모델 목록 및 관련 유틸리티
 */

// 지원되는 모든 모델 목록
export const SUPPORTED_MODELS = [
  // GPT 모델들
  { id: 'gpt-4o', name: 'GPT-4o', provider: 'openai', category: 'gpt' },
  { id: 'gpt-4o-mini', name: 'GPT-4o Mini', provider: 'openai', category: 'gpt' },
  
  // Claude 모델들
  { id: 'claude-sonnet-4-20250514', name: 'Claude Sonnet 4', provider: 'anthropic', category: 'claude' },
  { id: 'claude-opus-4-20250514', name: 'Claude Opus 4', provider: 'anthropic', category: 'claude' },
  
  // Gemma 모델들
  { id: 'gemma3:4b', name: 'Gemma3 4B', provider: 'google', category: 'gemma' },
  
  // Llama 모델들
  { id: 'llama3.2:3b', name: 'Llama 3.2 3b', provider: 'meta', category: 'llama' }
];

// 현재 애플리케이션에서 주로 사용하는 모델들 (기존 호환성 유지)
export const DEFAULT_MODELS = [
  { id: 'gemma3:4b', name: 'gemma3:4b' },
  { id: 'llama3.2:3b', name: 'llama3.2:3b' }
];

// 기본 모델 ID
export const DEFAULT_MODEL_ID = 'gemma3:4b';

/**
 * 모든 지원되는 모델 목록 반환
 * @returns {Array} 지원되는 모든 모델 배열
 */
export function getAllSupportedModels() {
  return [...SUPPORTED_MODELS];
}

/**
 * 기본 모델 목록 반환 (기존 호환성 유지)
 * @returns {Array} 기본 모델 목록
 */
export function getDefaultModels() {
  return [...DEFAULT_MODELS];
}

/**
 * 모델 ID로 모델 정보 찾기
 * @param {string} modelId - 찾을 모델 ID
 * @returns {Object|null} 모델 정보 또는 null
 */
export function findModelById(modelId) {
  return SUPPORTED_MODELS.find(model => model.id === modelId) || null;
}

/**
 * 기본 모델 반환
 * @returns {Object} 기본 모델 정보
 */
export function getDefaultModel() {
  return findModelById(DEFAULT_MODEL_ID) || DEFAULT_MODELS[0];
}

/**
 * 모델 목록을 기존 형태로 변환 (id, name만 포함)
 * @param {Array} models - 변환할 모델 배열
 * @returns {Array} 변환된 모델 배열
 */
export function toSimpleModelFormat(models = DEFAULT_MODELS) {
  return models.map(model => ({
    id: model.id,
    name: model.name || model.id
  }));
}

/**
 * 카테고리별 모델 그룹핑
 * @returns {Object} 카테고리별로 그룹핑된 모델 객체
 */
export function getModelsByCategory() {
  return SUPPORTED_MODELS.reduce((acc, model) => {
    const category = model.category || 'other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(model);
    return acc;
  }, {});
}

/**
 * 제공자별 모델 그룹핑
 * @returns {Object} 제공자별로 그룹핑된 모델 객체
 */
export function getModelsByProvider() {
  return SUPPORTED_MODELS.reduce((acc, model) => {
    const provider = model.provider || 'unknown';
    if (!acc[provider]) {
      acc[provider] = [];
    }
    acc[provider].push(model);
    return acc;
  }, {});
}

/**
 * 모델 ID가 유효한지 확인
 * @param {string} modelId - 확인할 모델 ID
 * @returns {boolean} 유효 여부
 */
export function isValidModelId(modelId) {
  return SUPPORTED_MODELS.some(model => model.id === modelId);
}

/**
 * 기존 호환성을 위한 하드코딩된 모델 목록 (레거시)
 * @deprecated getDefaultModels() 사용 권장
 */
export const LEGACY_MODEL_LIST = [
  { id: 'gemma3:4b', name: 'gemma3:4b' },
  { id: 'gemma3:27b', name: 'gemma3:27b' },
  { id: 'llama3.2:3b', name: 'llama3.2:3b' }
]; 